<template>
  <ClientBadge :client="agent" :label="label" :href="href" :name="name" />
</template>

<script>
import ClientBadge from "./ClientBadge.vue";
import {
  formatAgentType,
  getClientFullName
} from "./services/client-display.helpers.js";

/** Renders an agent as a ClientBadge, linking to their partner record. */
export default {
  name: "ShowAgent",
  components: { ClientBadge },
  props: {
    agent: {
      type: Object,
      default: null
    }
  },
  computed: {
    /**
     * @returns {string} Agent role label, e.g. "Agent", "OTA"
     */
    label() {
      return formatAgentType(this.agent && this.agent.type);
    },
    /**
     * @returns {string} Link to the agent's partner record, empty when unassigned
     */
    href() {
      return this.agent ? `/partners/${this.agent._id}` : "";
    },
    /**
     * @returns {string} Agent's full name, "Unassigned" when there's no agent
     */
    name() {
      return getClientFullName(this.agent);
    }
  }
};
</script>
